module.exports = __webpack_public_path__ + "static/student-sandbox-bg-lg-7cb2eea39581026bee507b2ea3fc9629.jpg";